type PrerequisitePromiseFunction = () => Promise<any>;

const prerequisiteCallbacks: PrerequisitePromiseFunction[] = [];

/** return promise indicating when it is safe to issue a new request */
export function getRequestPrerequisitePromise(): Promise<any[]> {
	const promises = prerequisiteCallbacks.map((f) => f());
	return Promise.all(promises);
}

/** register a callback function to be called before executing any new request */
export function registerRequestPrerequisiteCallback(callback: PrerequisitePromiseFunction): void {
	prerequisiteCallbacks.push(callback);
}
